import { render, staticRenderFns } from "./TravelsSimulator.vue?vue&type=template&id=21b79787"
import script from "./TravelsSimulator.vue?vue&type=script&lang=js"
export * from "./TravelsSimulator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports